import React from 'react';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const EmptyState = ({ value }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.regular14}
        align="center"
      >
        No results found{value ? ` for ‘${value}’` : ''}
      </CustomTypography>
    </div>
  );
};

EmptyState.propTypes = {
  value: PropTypes.string,
};

EmptyState.defaultProps = {
  value: '',
};
